import React from 'react'
import { GetSourceFn } from 'types/common'
import KNumberInput from 'ui-shared/WrappedInputs/KNumberInput'

type ProductQuantityInputProps = {
  getSource?: GetSourceFn
  disabled?: boolean
}

const EventProductQuantityInput: React.FC<ProductQuantityInputProps> = ({
  getSource,
  disabled,
}) => {
  return (
    <KNumberInput
      source={getSource!('quantity')}
      label="form.fields.quantity"
      disabled={disabled}
      style={{ marginRight: '16px' }}
    />
  )
}

export default EventProductQuantityInput
